// Config
import {servicesToDisplayDurationConfig} from "@/config/servicesToDisplayDurationConfig"


export const isServiceToDisplayDuration = (serviceName: string): boolean => {
    if(!serviceName) throw new Error(`service name is mandatory in isServiceToDisplayDuration, received >>: ${serviceName}`) 
    return servicesToDisplayDurationConfig.has(serviceName)
}   